<template>
  <div class="dashboard-container">
    <van-action-sheet v-model="showBank" :actions="actions" cancel-text="" :description="this.$t('cash.chooseWallet')"
      close-on-click-action @select="onSelect" />
    <div v-if="setPwd" class="real_name_mask" @click="setPwd = false">
      <div class="real_box" @click.stop>
        <div class="tit" />
        <p class="tips" style="font-size: 16px; ">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <div class="basic_btn" @click="setIniPwd">
          <span style="color: #ffffff;"> {{ $t('cash.setNow') }}</span>
        </div>
      </div>
    </div>
    <van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
      <div class="psw_box">
        <van-password-input :value="psd_val" :mask="true" :focused="showKeyboard" @focus="showKeyboard = true" />
        <div class="keybord_box">
          <div class="keybord">
            <div class="key_item" v-for="i in 9" @click="onInput(i)">
              <div class="key_inner">{{ i }}</div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner"></div>
            </div>
            <div class="key_item" @click="onInput(0)">
              <div class="key_inner">0</div>
            </div>
            <div class="key_item no_bg x" @click="onDelete">
              <div class="key_inner">x</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showWithdraw" position="right">
      <div class="main-box">
        <div class="personal-data-page withdraw-box">
          <!-- 顶部导航 -->
          <div class="title-box">
            <button class="back" @click="showWithdraw = false">
              <i class="iconfont icon-zuojiantou2"></i>
            </button>
            <h2>{{ $t('提款') }}</h2>
            <button class="btns" @click="tabFun(2)">
              {{ $t('细节') }}
            </button>
          </div>
          <div class="infos" style="border-bottom: 1px solid #265145;">
            <div class="lis">
              <span class="t">{{ $t('提款方式') }}</span>
              <!-- <span class="t-2" v-if="bankList.length > 0">{{ $t('银行卡') }}</span> -->
            </div>
            <div class="lis2" v-if="bankList.length == 0">
              <div class="inputs"
                style="background: #222725;line-height: 18px;font-size: 14px;color:#F1EDDE;height: fit-content;padding: 10px 15px;">
                {{ $t('Note2') }}
              </div>
              <a class="qb-btn" @click="$router.push('/account')">{{ $t('前往钱包设置') }}<i
                  class="iconfont icon-jiantou"></i></a>
            </div>
            <div class="lis2" v-if="bankList.length != 0">
              <div class="inputs" @click="showBank = true"
                style="background: #222725;line-height: 18px;font-size: 14px;color:#F1EDDE;height: fit-content;padding: 10px 15px;">
                {{ bank_name != '' ? bank_name : $t('cash.chooseWallet') }}
              </div>
            </div>

          </div>
          <div class="infos">
            <div class="lis"
              style="margin-bottom: 0px;display: flex; flex-direction: column;width: 100%;align-items: flex-start;">
              <span class="t" style="margin-bottom: 10px;">{{ $t('可提款金额') }}:</span>
              <span class="t3">{{ $cut2 }} {{ userInfo != null ? userInfo.money : '0.00' }}</span>
            </div>
          </div>
          <div class="infos">
            <!-- <div class="lis">
              <span style="font-size: 14px;color: #B3B9BF;">{{ $t('卖') }}</span>
              <span style="font-size: 14px;color: #B3B9BF;">{{ $t('最低') }} 2{{ $cut2 }}</span>
            </div> -->
            <div class="lis3" style="display: flex;">
              <div class="inputs"
                style="border: 1px solid #BAC0C6;background: linear-gradient(90deg, rgba(20, 40, 52, 1) 0%, rgba(26, 48, 49, 1) 100%);">
                <input type="text" v-model="value" placeholder="0.00">
              </div>
              <a class="cut">{{ $cut2 }}</a>
            </div>
            <div class="lis" style="flex-direction: column;align-items: flex-start;">
              <span style="margin: 15px 0px 0px 0px;font-size: 10px;color: #FDE68A;">{{ $t('cash.arrivalTime') }}</span>
              <span v-if="userInfo !== null && value > userInfo.money"
                style="font-size: 10px;color: #E7B9BB;margin-top: 5px;">{{ $t('该金额超过了可提款余额')
                }}</span>
            </div>
            <!-- <div class="lis" style="border: 1px solid #2F4446;display: flex; flex-direction: column;width: 100%;align-items: flex-end;padding:12px 15px;border-radius: 12px;margin-top: 15px;margin-bottom: 0px;background: #0D2228;">
                            <span class="t" style="margin-bottom: 10px;color: #A4ACAE;font-size: 12px;">{{ $t('您将收到') }}</span>
                            <span class="t3" style="font-size: 24px;">{{ $cut2 }} {{ userInfo === null? '0.00':userInfo.money }}</span>
                        </div> -->
          </div>
          <div class="sub-btn-box">
            <div class="sub-btn" style="margin-top: auto;" :class="{ 'no-btn': value === '' || bankList.length == 0 }">
              <button class="btn" @click="setIniPwd(1)">
                {{ $t('提款') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 提现细节 -->
    <van-popup v-model="showWithdrawList" position="right">
      <div class="main-box">
        <div class="personal-data-page jl-box">
          <!-- 顶部导航 -->
          <div class="title-box" style="background: #06241D;">
            <button class="back" @click="showWithdrawList = false">
              <i class="iconfont icon-zuojiantou2"></i>
            </button>
            <h2 style="display: flex;flex-direction: column;">
              <span>{{ $t('细节') }}</span>
            </h2>
          </div>
          <div class="tab-boxs">
            <a :class="{ 'active': tabIndex === index }" v-for="(item, index) in tabList" :key="index"
              @click="tabFun(index)">
              {{ $t(item) }}
            </a>
          </div>
          <div class="uls-box" v-if="list2.length === 0" style="padding: 15px;">
            <div
              style="background:#193631;display: flex;flex-direction: column;padding:30px 20px;justify-content: center;align-items: center;border: 1px solid #294540;border-radius: 12px;">
              <span style="color: #93A19E;font-size:14px;">{{ $t('未找到交易记录') }}</span>
            </div>
          </div>
          <div v-else class="uls-box" style="padding: 15px;">
            <div class="lis" v-for="(item, index) in list2" :key="index">
              <div class="t" v-if="tabIndex === 0">
                <span>{{ $t('项目名称') }}</span>
                <span>{{ $t(item.title) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 3">
                <span>{{ $t('兑换码') }}</span>
                <span>{{ $t(item.code) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 3">
                <span>{{ $t('奖励金额') }}</span>
                <span>{{ $t(item.reward_amount) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 3">
                <span>{{ $t('兑换时间') }}</span>
                <span>{{ $t(item.create_time) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 1 || tabIndex === 2">
                <span>{{ $t('金额') }}</span>
                <span style="color: #FDE68A;font-weight: bold;">{{ $cut2 }} {{ $t(item.money) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 1 || tabIndex === 2">
                <span>{{ $t('订单编号') }}</span>
                <span>{{ $t(item.orderid) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 1 || tabIndex === 2">
                <span>{{ $t('状态') }}</span>
                <span style="color: #CBCB41;" v-if="item.status === 3">{{ $t('PendingReview') }}</span>
                <span style="color: #25C582;" v-if="item.status === 1">{{ $t('Completed') }}</span>
                <span style="color: #D71804;" v-if="item.status === 2">{{ $t('Rejected') }}</span>
                <!-- <span style="color: #CBCB41;" v-if="item.status === 3">{{ $t('PendingSubmission') }}</span> -->
              </div>
              <div class="t" v-if="tabIndex === 0">
                <span>{{ $t('投资金额') }}</span>
                <span style="color: #FDE68A;font-weight: bold;">{{ $cut2 }} {{ $t(item.money) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 0">
                <span>{{ $t('预计收益') }}</span>
                <span>{{ item.rate }}%</span>
              </div>
              <div class="t" v-if="tabIndex === 0">
                <span>{{ $t('结算状态') }}</span>
                <span style="color: #CBCB41;" v-if="item.status === 0">{{ $t('orders.unfinish') }}</span>
                <span style="color: #25C582;" v-if="item.status === 1">{{ $t('orders.finish') }}</span>
              </div>

              <div class="t" v-if="tabIndex !== 3">
                <span>{{ $t('订单创建时间') }}</span>
                <span>{{ $t(item.time) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 2 && item.status === 2 && item.remark != null || tabIndex === 1 && item.status === 2 && item.remark != null">
                <span>{{ $t('拒绝原因') }}</span>
                <span style="color: #D71804;">{{ $t(item.remark) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 2 && item.status === 1 && item.type == 999 || tabIndex === 1 && item.status === 1 && item.type == 999">
                <span>{{ $t('备注') }}</span>
                <span style="color: #D71804;">{{ $t(item.remark) }}</span>
              </div>
              <div class="t" v-if="tabIndex === 0">
                <span>{{ $t('投资时长') }}</span>
                <span>{{ $t(item.day_text) }}</span>
              </div>
            </div>
          </div>
          <div style="height: 80px;"></div>
        </div>
      </div>
    </van-popup>
    <!-- 顶部导航栏 -->
    <header class="top-nav">
      <div class="user-info" v-if="userInfo != null">
        <div class="avatar">
          <span class="avatar-text">L</span>
        </div>
        <div class="wallet-id">
          <span class="wallet-number">{{ userInfo.mobile ? userInfo.mobile : userInfo.email }}</span>
        </div>
        <div class="wallet-id" style="border: 1px solid #3F5E59;background: #294041;" @click="copyText">
          <i class="iconfont icon-fuzhi-"></i>
          <span>{{ $t('invest_bank.copy') }}</span>
        </div>
        <div class="wallet-id" @click="tabFun(0)">
          <i class="iconfont icon-shijian"></i>
        </div>
      </div>
    </header>

    <!-- 资产卡片区域 -->
    <section class="asset-card">
      <div class="box">
        <div class="boxs">
          <div class="asset-item">
            <span class="asset-label">{{ $t('user.availableBalance') }} ({{ $cut2 }})</span>
            <h1 class="asset-value">{{ userInfo !== null ? userInfo.money : '0.0000' }}</h1>
          </div>

          <div class="asset-actions">
            <button class="btn btn-withdrawal" @click="showWithdrawFuns">{{ $t('Withdrawal') }}</button>
            <button class="btn btn-deposit" @click="$router.push('/deposit')">{{ $t('moneybag.recharge') }}</button>
          </div>

          <!-- <div class="asset-item" style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="flexs">
                        <span class="asset-label">Applied discounts (USDT)</span>
                        <h1 class="asset-value">0.00</h1>
                    </div>
                    <button class="btn btn-coupons">My coupons</button>
                </div> -->
        </div>
      </div>
    </section>

    <!-- 横幅广告区域 -->
    <section class="banner-ad">
      <img src="../../assets/images/banner2.jpg" alt="SAQUES 24 HORAS" class="banner-image" />
    </section>

    <!-- 交易记录区域 -->
    <section class="transactions-section">

      <div class="section-header">
        <h2>{{ $t('RecentTransactions') }}</h2>
        <button class="details-btn" @click="tabFun(0)">{{ $t('MoreDetails') }} ></button>
      </div>
      <div class="transactions-empty" v-if="list.length == 0">
        <p>{{ $t('notransactions') }}</p>
      </div>
      <div v-else class="uls-box">
        <div class="lis" v-for="(item, index) in list" :key="index">
          <div class="t">
            <span>{{ $t('项目名称') }}</span>
            <span>{{ $t(item.title) }}</span>
          </div>
          <div class="t">
            <span>{{ $t('utils.investmentAmount') }}</span>
            <span style="color: #FDE68A;font-weight: bold;">{{ $cut2 }} {{ $t(item.money) }}</span>
          </div>
          <div class="t">
            <span>{{ $t('shouyi_yj') }}</span>
            <span>{{ item.rate }}%</span>
          </div>
          <div class="t">
            <span>{{ $t('结算状态') }}</span>
            <span style="color: #CBCB41;" v-if="item.status === 0">{{ $t('orders.unfinish') }}</span>
            <span style="color: #25C582;" v-if="item.status === 1">{{ $t('orders.finish') }}</span>
          </div>

          <div class="t">
            <span>{{ $t('订单创建时间') }}</span>
            <span>{{ $t(item.time) }}</span>
          </div>
          <div class="t">
            <span>{{ $t('投资时长') }}</span>
            <span>{{ $t(item.day_text) }}</span>
          </div>
        </div>
      </div>
    </section>
    <div style="height: 100px;"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from "../../utils/fetch";
import {
  PasswordInput,
  NumberKeyboard,
  ActionSheet,
  Toast,
  Dialog
} from 'vant';
Vue.use(PasswordInput).use(NumberKeyboard).use(ActionSheet).use(Dialog)
let timeOut = null;
export default {
  created() {
    this.$parent.footer('mine');
    Fetch("/user/info").then((r) => {
      this.userInfo = r.data;
    });
    Fetch("/user/order").then((r) => {
      this.list = r.data.list.slice(0, 5);
    });
  },
  name: 'AssetDashboard',
  data() {
    return {
      userInfo: null,
      showWithdraw: false,
      showWithdrawList: false, //显示提现细节
      list: [],
      list2: [],
      tabIndex: 0,
      value: '',
      tabList: ['投资', '充值', 'index.withdraw', '兑换码'],
      bankList: [],
      setPwd: false,
      submitType: 1,
      write_psd: false,
      showKeyboard: true,
      psd_val: '',
      zf_passwrod: '',
      showBank: false,
      chargeTip: '',
      bank_id: '',
      charge: '',
      type: '',
      rate: '',
      mark: '',
      user_name: '',
      bank_name: '',
      actions: [],
      maxMoney: ''
    }
  },
  mounted() {
    timeOut = setInterval(() => {
      Fetch("/user/info", {}, {}, false).then((r) => {
        this.$set(this, 'userInfo', r.data)
      });
    }, 5000)
  },
  beforeDestroy() {
    // 先判断定时器是否存在，避免报错
    if (timeOut) {
      clearInterval(timeOut);
      timeOut = null; // 清空引用，防止内存泄漏
    }
  },
  methods: {
    // 复制钱包地址
    copyText() {
      try {
        console.log(window.location)
        const currentDomain = window.location.protocol + '//' + window.location.host + '#/register?invite_code=' + this.userInfo.invite_code;
        // 创建临时输入框实现复制
        const input = document.createElement('input');
        input.value = currentDomain;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        // 提示复制成功（可替换为你的全局提示组件）
        this.$toast(this.$t('复制成功'))
      } catch (err) {
        this.$toast(this.$t('复制失败'))
        console.error('复制失败：', err);
      }
    },
    showWithdrawFun() {
      this.showWithdrawList = true
    },
    showWithdrawFuns() {
      Fetch('/user/my_bank').then((r) => {
        if (r.code == 1) {
          // console.log(r, 'rrr')
          this.money = r.data.money
          this.bankList = r.data.bank
          this.setPwd = r.data.intPwd;
          var bankvalue = []
          r.data.bank.forEach(item => {
            var length = item.user.length;
            var account = item.user + "";
            var itemAccount = account.substr(length - 4, length)
            bankvalue.push({
              name: item.bank + "(****" + itemAccount + ")",
              value: item.id,
              charge: item.charge,
              rate: item.rate,
              type: item.type,
              mark: item.mark,
              user: item.user
            })
          })
          bankvalue.push({
            name: this.$t('cash.addWallet'),
            value: 0,
            color: "#FF0000",
          })
          this.actions = bankvalue;
          console.log(this.setPwd)
          if (!this.setPwd) {
            
            if(this.bankList.length > 0) {
              this.showWithdraw = true
            }else {
              Dialog.confirm({
                  message: this.$t('暂无提款方式'),
                  confirmButtonText: this.$t('utils.confirm'),
                  cancelButtonText: this.$t('utils.cancel')
              }).then(() => {
                  this.$router.push("/account");
              }).catch(() => {
                  // on cancel
              });
            }
          }
        } else {
          this.bankList = []
          this.$toast(r.msg)
        }
      });
    },
    onSelect(item) {
      this.value = "";
      this.showBank = false;
      this.bank_name = item.name;
      this.user_name = item.user || ''
      this.bank_id = item.value;
      this.charge = item.charge;
      this.type = item.type;
      this.rate = item.rate;
      this.mark = item.mark;
      if (item.charge > 0) {
        this.chargeTip = this.$t('cash.charge') + item.charge + "%";
      } else {
        this.chargeTip = "";
      }
      this.submitType = 1;
      if (item.value == 0) {
        this.$router.push('/addcountUsdt')
      }
    },
    onInput(key) {
      this.psd_val = (this.psd_val + key).slice(0, 6);
      if (this.psd_val.length == 6) {
        this.write_psd = false;
        this.zf_passwrod = this.psd_val;
        console.log(this.submitType, 'submitType')
        if (this.submitType == 1) {
          this.submit();
        } else {
          this.setIniPwdSubmit();
        }

      }
    },
    submit() {
      this.psd_val = "";
      if (!this.zf_passwrod) {
        this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
        return false;
      }
      Fetch('/user/cost_apply', {
        money: this.value,
        bank_id: this.bank_id,
        passwd: this.zf_passwrod
      }).then((r) => {
        if (r.code == 1) {
          Toast(r.info)
          setTimeout(() => {
            this.showWithdraw = false
          }, 500);
        } else {
          Toast(r.msg)
        }
      });
    },
    setIniPwdSubmit() {
      this.psd_val = "";
      let data = {
        password: this.zf_passwrod
      }
      Fetch('/user/setIniPwd', data).then((r) => {
        if (r.code == 1) {
          Toast(r.info)
          this.zf_passwrod = ''
          setTimeout(() => {
            this.setPwd = false;
          }, 500);
        } else {
          Toast(r.msg)
        }
      });
    },
    onDelete() {
      this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
    },
    setIniPwd(type) {
      if (type === 1) {
        if (this.bankList.length === 0) {
          return
        }
        if (!this.value) {
          this.$toast(this.$t('cash.withdrawalAmountEmpty'));
          return false;
        }
        if (this.value < 0) {
          this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
          return false;
        }
        if (parseInt(this.value) > parseInt(this.money)) {
          this.$toast(this.$t('cash.withdrawalAmountHigh'));
          return false;
        }
        if (this.bank_id == 0 || this.bank_id == -1) {
          this.$toast(this.$t('cash.withdrawalAccountEmpty'));
          return false;
        }
        this.write_psd = true;
        return
      }
      this.submitType = 2;
      this.setPwd = false;
      this.write_psd = true;
    },
    tabFun(index) {
      this.tabIndex = index
      this.list2 = []
      if (index === 3) {
        Fetch('/redeem/info').then((r) => {
          if (r.code == 1) {
            // console.log(r.data, 'rrr')
            this.list2 = r.data.list
          } else {
            this.$toast(r.msg)
          }
        });
      }
      if (index === 2) {
        Fetch('/user/cash_list').then((r) => {
          if (r.code == 1) {
            // console.log(r.data, 'rrr')
            this.list2 = r.data
          } else {
            this.$toast(r.msg)
          }
        });
      }
      if (index === 1) {
        Fetch('/user/recharge_list').then((r) => {
          if (r.code == 1) {
            // console.log(r.data, 'rrr')
            this.list2 = r.data
          } else {
            this.$toast(r.msg)
          }
        });
      }
      if (index === 0) {
        Fetch('/user/order').then((r) => {
          if (r.code == 1) {
            // console.log(r.data, 'rrr')
            this.list2 = r.data.list
          } else {
            this.$toast(r.msg)
          }
        });
      }
      this.showWithdrawFun()
    }
  }
}
</script>

<style scoped lang="less">
/* 全局容器样式 */
.dashboard-container {
  width: 100%;
  margin: 0 auto;
  background: rgb(6, 14, 23);
  background-image: radial-gradient(760px 440px at 95% 0%, rgba(250, 204, 21, .11), transparent 62%), radial-gradient(840px 560px at -10% 2%, rgba(56, 189, 248, .08), transparent 64%), radial-gradient(780px 520px at 42% 100%, rgba(52, 211, 153, .07), transparent 64%);
  min-height: 100dvh;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  padding-bottom: 80px;
}

/* 顶部导航栏 */
.top-nav {
  padding: 20px 16px 16px;
  width: 100%;
  min-height: 50px;
  height: fit-content;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #28C886;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  color: #222;
}

.wallet-id {
  width: fit-content;
  height: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #546062;
}

.wallet-number {
  font-size: 14px;
  color: #ffffff;
}

.copy-btn {
  background-color: #2ccf70;
  border: none;
  color: #ffffff;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.more-btn {
  background: none;
  border: none;
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
}

/* 资产卡片区域 */
.asset-card {
  background-image: linear-gradient(128deg, #15324a, #10293d 56%, #0b1c2e);
  margin: 0 16px 16px;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  border: 1px solid #364246;

  .box {
    width: 100%;
    height: 160px;
  }

  .boxs {
    width: 100%;
    height: 100%;
    padding: 20px;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 1;
  }

  .box::after {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 0;
    opacity: 0.2;
    background: url('../../assets/images/wallet.jpg') no-repeat center center / 100% 100%;
  }
}


.asset-label {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
}

.asset-value {
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  margin: 10px 0 16px 0;
}

.asset-actions {
  display: flex;
  margin-bottom: 30px;
  justify-content: space-between;
}

.btn {
  padding: 12px 0;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #515E68;
}

.btn-withdrawal {
  width: 70%;
  background-color: rgba(0, 0, 0, 0.1);
  color: #ffffff;
}

.btn-deposit {
  width: 26%;
  background-color: #2DCC8E;
  color: #ffffff;
}

.btn-coupons {
  background-color: #ffffff;
  color: #222222;
  padding: 8px 16px;
  border-radius: 8px;
  height: 40px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

/* 横幅广告区域 */
.banner-ad {
  margin: 0 16px 16px;
  border-radius: 12px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 交易记录区域 */
.transactions-section {
  margin: 0 16px 20px;
  background: #112B41;
  border-radius: 15px;
  border: 1px solid #2B4156;
  padding: 20px;

  .uls-box {
    width: 100%;
    height: fit-content;

    .lis {
      border: 1px solid #2B4156;
      background: #0C1F32;
      padding: 10px;
      border-radius: 12px;
      margin-bottom: 12px;
      display: flex;
      flex-direction: column;

      .t {
        width: 100%;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;

        span {
          color: #E6F7EF;
        }

        span:last-child {
          color: #eee;
        }
      }

      .t:last-child {
        margin-bottom: 0px;
      }
    }
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.section-header h2 {
  font-size: 14px;
  margin: 0;
  font-weight: 600;
}

.details-btn {
  color: #eee;
  font-size: 12px;
  cursor: pointer;
  background: #0F263C;
  border: 1px solid #33485B;
  padding: 10px 8px;
  border-radius: 4px;
}

.transactions-empty {
  background-color: #182E43;
  border: 1px solid #2B4156;
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
}

.main-box {
  width: 100vw;
  max-width: 520px;
  height: 100dvh;
  position: relative;
  background-image: linear-gradient(90deg, #0d3a32, #082820 55%, #051a15);

  /* 页面容器 */
  .personal-data-page {
    width: 100%;
    height: 100dvh;
    overflow: hidden;
    overflow-y: scroll;
    // padding: 15px;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: relative;
    background: linear-gradient(180deg, #07161cf2, #051018eb 45%, #051614e6);
    background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 30;

    .sub-btn {
      width: 92%;
      height: 48px;
      background: #25C582;
      color: #222222;
      font-size: 14px;
      border-radius: 10px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .no-btn {
      background: #15915d;
    }

    /* 顶部导航栏 */
    .title-box {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 15px;
      height: 60px;
      position: sticky;
      top: 0px;
      z-index: 10;
      background: #072B22;
      border-bottom: 1px solid #265245;

      h2 {
        color: #E6F7EF;
        margin-left: 10px;
      }

      .btn,
      .back {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #375852;
        border-radius: 12px;
        padding: 8px 9px;
        color: #fff;
        margin-left: auto;
        background: none;

        .iconfont {
          font-size: 18px;
        }
      }

      .back {
        margin-left: 0px;
      }
    }

    .infos {
      padding: 15px;
      width: 100%;

      .lis,
      .lis2 {
        width: 100%;
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .t,
        .t2,
        .t3 {
          font-size: 14px;
        }

        .t {
          color: #A9D3C0;
        }

        .t2 {
          font-weight: bold;
        }

        .t3 {
          color: #E6F7EF;
        }
      }

      .lis2 {
        flex-direction: column;
        align-items: flex-start;

        .t {
          margin-bottom: 10px;
        }

        .t3 {
          margin-top: 10px;
          font-size: 14px;
          color: #9de6c6;
        }

        .inputs {
          width: 100%;
          height: 50px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5px 15px;
          border: 1px solid #365753;
          background: #133932;

          input {
            width: 80%;
            height: 100%;
            font-size: 16px;
            color: #FFFFFF;
          }

          .cut {
            width: fit-content;
            height: 32px;
            padding: 0px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #042018;
            border-radius: 8px;
            font-size: 14px;
            font-weight: bold;
            background: #28C689;
            border: 1px solid #62DDAC;
          }
        }
      }
    }

  }

  .withdraw-box {
    background: linear-gradient(180deg, #102131, #0d1a2a);

    .btns {
      margin-left: auto;
      font-size: 12px;
      color: #C5C9CD;
      border: 1px solid #3A4957;
      background: #172839;
      padding: 6px 8px;
      border-radius: 12px;
    }

    .infos {
      width: 92%;
      height: fit-content;
      margin-top: 10px;
      margin-bottom: 0px;
      border-radius: 12px;
      background: #0c2030;
      border: 1px solid #3A4957;

      .lis,
      .lis2 {
        margin-bottom: 10px;

        .t {
          color: #ffffff;
        }

        .t3 {
          font-size: 20px;
          color: #fff;
        }
      }

      .lis2 {
        margin-bottom: 0px;
      }

      .lis3 {
        flex-direction: row;
        margin-bottom: 0px;
        justify-content: space-between;

        .inputs {
          width: 85%;
          height: 42px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5px 15px;
          border: 1px solid #365753;
          background: #133932;

          input {
            width: 80%;
            height: 100%;
            font-size: 16px;
            color: #FFFFFF;
          }

        }

        .cut {
          width: fit-content;
          height: 42px;
          margin-left: 10px;
          padding: 0px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          border-radius: 8px;
          font-size: 14px;
          font-weight: bold;
          background: #152A32;
          border: 1px solid #D4D7DB;
        }
      }

    }

    .sub-btn-box {
      width: 100%;
      padding: 10px 15px 20px 15px;
      border-top: 1px solid #1F2E3B;
      display: flex;
      justify-content: center;
      height: fit-content;
      margin-top: auto;

      .sub-btn {
        width: 100%;

        button {
          width: 100%;
          border: none;
        }
      }
    }
  }

  .withdraw-box .title-box {
    background: linear-gradient(98deg, #133329, #0f2635 48%, #0b1b2c);
  }
}

.jl-box {
  .back {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 18px;
    margin-right: 15px;
  }

  .tab-boxs {
    width: 100%;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      width: 24%;
      display: flex;
      align-items: center;
      justify-content: center;
      /* 垂直居中保留 */
      /* 去掉 justify-content: center，改用文本居中 + 换行 */
      padding: 12px 6px;
      background: #17332E;
      border: 1px solid #37524C !important;
      border-radius: 10px;

      word-break: normal;
      /* 取消强制拆字符，恢复按单词换行 */
      word-wrap: break-word;
      /* 超长单词才拆行（避免溢出） */
      white-space: normal;
      text-align: center;
      /* 允许换行 */
    }

    .active {
      background: #25C582;
      color: #2d2d2d;
    }
  }

  .btns {
    margin-left: auto;
    font-size: 14px;
    color: #C9CAA3;
  }

  .title-box h2 {
    font-size: 18px;
    color: #fff;
    margin: 0;
  }

  .uls-box {
    width: 100%;
    height: calc(100dvh - 50px);
    overflow: hidden;
    overflow-y: scroll;

    .lis {
      border: 1px solid #265245;
      background: #153932;
      padding: 10px;
      border-radius: 12px;
      margin-bottom: 12px;
      display: flex;
      flex-direction: column;

      .t {
        width: 100%;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;

        span {
          color: #E6F7EF;
        }

        span:last-child {
          color: #eee;
        }
      }

      .t:last-child {
        margin-bottom: 0px;
      }
    }
  }

  /* 数据统计网格 */
  .stats-grid {
    width: 92%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .stats-item {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 15px;
    border: 1px solid #39675F;
  }

  .stats-label {
    font-size: 14px;
    color: #94BAAA;
    margin-bottom: 8px;
  }

  .stats-value {
    font-size: 20px;
    font-weight: 500;
  }

  /* 晋升奖励卡片 */
  .reward-card {
    width: 92%;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    margin: 0 15px 15px;
    padding: 15px;
    border: 1px solid #39675F;
  }

  .reward-label {
    font-size: 12px;
    color: #94BAAA;
    margin-bottom: 10px;
  }

  .reward-amount {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .reward-total {
    font-size: 12px;
    color: #94BAAA;
    margin-bottom: 15px;
  }

  .withdraw-btn {
    color: #FFD700;
    font-size: 12px;
    font-weight: 500;
  }

  /* 每周表现卡片 */
  .weekly-card {
    width: 92%;
    background: linear-gradient(130deg, #fbbf2438, #10b98124 60%, #065f4633);
    border-radius: 12px;
    margin: 0 15px 15px;
    padding: 15px;
    border: 1px solid #39675F;
  }

  .weekly-title {
    font-size: 12px;
    color: #E9E4B8;
    margin-bottom: 10px;
  }

  .weekly-progress {
    margin-bottom: 8px;
  }

  .progress-text {
    font-size: 16px;
    font-weight: 500;
  }

  .weekly-period {
    font-size: 12px;
    color: #E9E4B8;
    margin-bottom: 12px;
  }

  .progress-bar {
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    margin-bottom: 12px;
  }

  .progress-inner {
    height: 100%;
    background: #34D399;
    border-radius: 3px;
  }

  .weekly-reward {
    font-size: 12px;
    color: #E9E4B8;
    margin-bottom: 8px;
  }

  .weekly-status {
    font-size: 12px;
    color: #ffffff;
  }

  /* 每日限额 */
  .daily-limit {
    width: 92%;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    margin: 0 15px 15px;
    padding: 15px;
    font-size: 12px;
    color: #94BAAA;
    border: 1px solid #39675F;
  }

  /* 提交区域 */
  .submit-section {
    width: 92%;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    margin: 0 15px 15px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    border: 1px solid #39675F;

    input {
      width: 100%;
      height: 40px;
      padding: 0 10px;
      font-size: 14px;
      color: #ffffff;
    }
  }

  .submit-title {
    font-size: 12px;
    font-weight: bold;
    color: #C0E7D4;
    margin-bottom: 10px;
  }

  .submit-input {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .submit-btn {
    background: #34D399;
    border: none;
    border-radius: 8px;
    color: #06241D;
    font-weight: 500;
    width: 100%;
    height: 40px;
    font-size: 14px;
  }

  /* 提交历史 */
  .history-section {
    width: 92%;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    margin: 0 15px;
    border: 1px solid #39675F;
    overflow: hidden;

    .boxs {
      width: 100%;
      height: fit-content;
      overflow: hidden;
      overflow-x: scroll;
    }
  }

  .history-title {
    font-size: 12px;
    font-weight: 500;
    padding: 10px 15px;
    display: flex;
    align-items: center;
  }

  .history-tabs {
    width: fit-content;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 10px 15px;
    font-size: 12px;
    background: #0C2F27;
  }

  .history-li {
    width: fit-content;
    height: fit-content;
    padding: 10px 15px;
    color: #83AC9D;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #39675F;
  }

  .tab-item {
    display: block;
    font-size: 12px;
    color: #94BAAA;
    text-align: center;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .tab-item:nth-child(1) {
    text-align: left;
  }
}

.psw_box {
  padding-top: 20px;
}

.keybord_box {
  height: 250px;
  background-color: #F0F0F0;
  margin-top: 35px;
  padding: 14px 12px 0 12px;
  margin: 0 auto;
  display: flex;
  justify-content: center;

  .keybord {
    width: 361px;
    margin: 24px auto 0 atuo;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: center;

    .key_item {
      width: 115px;
      height: 44px;
      line-height: 44px;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 6px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;

      .key_inner {
        color: #2d2d2d;
      }

      &.no_bg {
        background: none;
      }

      &.x {
        color: #757880;
        font-weight: bold;
      }
    }
  }
}

.qb-btn {
  font-size: 12px;
  padding: 6px 10px;
  border: 1px solid #274245;
  margin-top: 10px;
  border-radius: 8px;
  background: #152A32;
  color: #889198;
  margin-left: auto;
  display: flex;
  align-items: center;

  .iconfont {
    font-size: 10px;
  }
}
</style>